function formatTimestamp(tstamp = /* @__PURE__ */ new Date(), options) {
  const date = String(tstamp.getDate());
  const month = String(tstamp.getMonth() + 1);
  const year = String(tstamp.getFullYear());
  const dateSeparator = (options == null ? void 0 : options.dateSeparator) ?? "-";
  const formattedDate = `${date.padStart(
    2,
    "0"
  )}${dateSeparator}${month.padStart(2, "0")}${dateSeparator}${year}`;
  if (!(options == null ? void 0 : options.includeTime)) {
    return formattedDate;
  }
  const minutes = String(tstamp.getMinutes());
  const hours = String(tstamp.getHours());
  const timeSeparator = (options == null ? void 0 : options.timeSeparator) ?? ":";
  return `${formattedDate} ${hours}${timeSeparator}${minutes.padStart(2, "0")}`;
}

export { formatTimestamp };
//# sourceMappingURL=date.format-timestamp.js.map
